export var NAVIGATION_ITEM_TYPES = {
    link: 'link',
    menu: 'menu'
};
